import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { reduxForm, getFormValues } from 'redux-form';

import { ErrorsSection, LoadingWithDescription } from 'src/components';
import Button from 'jbc-front/components/Button';
import { getExtras } from 'src/reducers/common/listReducer';
import { DateField, CheckboxField, SelectField } from 'src/jbc-front/components/Form';
import CommonModal from 'jbc-front/components/CommonModal';
import { FormSubmitBtn } from 'src/buttons';
import { CONFIRM_PAYROLL_GROUP } from 'src/constants/FormNames';
import {
  REDUCER_NAME,
  changePayrollGroupConfirm,
  getConfirmPayrollGroupErrors,
  getEmployeePayListExtras,
  clearErrors
} from 'src/reducers/employees/employeePays';
import { get24HoursOptions } from 'src/utils/Form';
import { isDateStringFormat } from 'src/utils/CustomValidators';
import ConfirmDate from './ConfirmDate';
import styles from './ConfirmPayrollGroupModal.scss';
import { useTranslation } from 'react-i18next';
import selector from 'src/utils/Utils';
import { LANGUAGE_OPTIONS } from 'src/constants/Options';

const DEFAULT_RELEASE_HOUR = '9';

const genInitialValue = extras => {
  const { paymentDate } = extras || {};
  if (isEmpty(paymentDate)) {
    return {};
  }
  return { releaseDate: paymentDate, releaseHour: DEFAULT_RELEASE_HOUR, sendNotifyToEmployee: false };
};

const ConfirmPayrollGroupInsideForm = ({
  handleSubmit,
  submitting,
  submit,
  cancelBtnClick,
  selectedYearMonth,
  extras,
  errors,
  header,
  isSendNotifyToEmployee
}) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <CommonModal.Header hideModal={cancelBtnClick}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <form onSubmit={handleSubmit}>
          <ErrorsSection errors={errors} />
          {submitting && (
            <div className="u-mb20">
              <LoadingWithDescription text={t('features.EmployeeBonus.components.ConfirmBonusModal.Confirming_Please_wait')} />
            </div>
          )}
          <ConfirmDate yearMonth={selectedYearMonth.label} paymentDate={extras.paymentDate} />
          <div className={styles.selectWrap}>
            <DateField
              required
              name="releaseDate"
              label={t('features.EmployeePays.components.ChangePayReleaseDateForm.Payslip_disclosure_time_to_employee')}
              validate={isDateStringFormat}
            />
            <SelectField
              label={t('features.EmployeePays.components.ChangePayReleaseDateForm.time')}
              name="releaseHour"
              options={get24HoursOptions()}
              width={100}
              required
            />
          </div>
          <div>
            <CheckboxField name="sendNotifyToEmployee" label={t('features.Employees.components.ConfirmPayrollGroupModal.Also_send_email_notification_when_disclosed')} />
          </div>
          {isSendNotifyToEmployee && (
            <div className={styles.selectWrap}>
              <SelectField label={t('features.EmployeePays.components.ChangePayReleaseDateForm.language_of_notification_email')} name="locale" options={LANGUAGE_OPTIONS} width={100} required />
            </div>
          )}
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={cancelBtnClick} className="u-mr20">
          {t('features.EmployeeBonus.components.ActionButtonSection.cancel')}
        </Button>
        <FormSubmitBtn text={t('features.EmployeePays.components.ChangePayReleaseDateForm.Confirm')} {...{ submitting, submit }} />
      </CommonModal.Footer>
    </React.Fragment>
  );
};

let ConfirmPayrollGroupForm = reduxForm({
  form: CONFIRM_PAYROLL_GROUP
})(ConfirmPayrollGroupInsideForm);
const mapStateToProp = state => ({
  initialValues: genInitialValue(getEmployeePayListExtras(state)),
  extras: getExtras(REDUCER_NAME, state),
  errors: getConfirmPayrollGroupErrors(state),
  isSendNotifyToEmployee: selector(getFormValues(CONFIRM_PAYROLL_GROUP)(state), 'sendNotifyToEmployee')
});
const mapDispatchToProp = (dispatch, ownProps) => ({
  clearErrors: dispatch(clearErrors()),
  onSubmit: data => {
    dispatch(changePayrollGroupConfirm(data, ownProps.selectedPayroll));
    if (typeof ownProps.hideModal === 'function') {
      ownProps.hideModal();
    }
  }
});

ConfirmPayrollGroupForm = connect(mapStateToProp, mapDispatchToProp)(ConfirmPayrollGroupForm);

const ConfirmPayrollGroupModal = ({ isOpen, hideModal, selectedPayroll, selectedYearMonth }) => {
  const { t } = useTranslation();
  const header = t('features.EmployeePays.components.ConfirmPayrollContainer.Salary_confirmation');

  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <ConfirmPayrollGroupForm
        cancelBtnClick={hideModal}
        hideModal={hideModal}
        {...{ selectedPayroll, selectedYearMonth }}
        header={header}
      />
    </CommonModal>
  );
};

export default ConfirmPayrollGroupModal;
